import React, { useEffect } from "react";
import { clearAppStoragePreserveBranding } from "./brandingUtils";
const events = [
  "load",
  "mousemove",
  "mousedown",
  "click",
  "scroll",
  "keypress",
];

const AppLogout = ({ children }) => {
  let timer;

useEffect(() => {
  Object.values(events).forEach((item) => {
    window.addEventListener(item, () => {
      resetTimer();
      handleTimer();
    });
  });
}, []);

const resetTimer = () => {
  if (timer) clearTimeout(timer);
};

const handleTimer = () => {
  timer = setTimeout(() => {
    resetTimer();
    Object.values(events).forEach((item) => {
      window.removeEventListener(item, resetTimer);
    });
    logoutAction();
  }, 1000*60*60*8);
};

// 1000*60*60*8

const logoutAction = () => {
  clearAppStoragePreserveBranding();
  window.location.pathname = "/login";
};
  return children;
};

export default AppLogout;
